/**
 * @description 裝置類型 (enum)
 */
export enum DeviceTypesEnum {
  /** 電腦 */
  PC = 'Pc',
  /** 行動裝置 */
  Mobile = 'Mobile'
}
